// @core/api/endpoints/payment/retry_provider_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RetryProviderEventRequest,
  RetryProviderEventResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Retry processing of a provider event
 * Performs retry operation on provider event.
 */
export async function RetryProviderEvent(
  id: string,
  data: RetryProviderEventRequest,
  options?: RequestOptions
): Promise<RetryProviderEventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/provider-events/:id/retry`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<RetryProviderEventResponse>(requestPath, data, requestOptions);
}
